import { render, staticRenderFns } from "./FormControlPortalSitesBuildName.vue?vue&type=template&id=91350220"
import script from "./FormControlPortalSitesBuildName.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPortalSitesBuildName.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports